import React from 'react';

const BUNDLE_ITEM_TYPE_ID = 6;
const TOKEN_ITEM_TYPE_ID = 9;

/** @param {string} type - can be "sentence" or "list" to change the dispaly type  */
export const TokenQtyMsg=({item, type="sentence"})=>{

    const getTokensList=(product, includeName)=>{
        if(product?.product_type_id === TOKEN_ITEM_TYPE_ID) {
            return(
                <li>
                  {product?.quantity} {includeName && `${product.name}`} token{product.quantity > 1 ? "s" : ""}
                </li>
            )   
        }else if(product?.product_type_id === BUNDLE_ITEM_TYPE_ID && product?.bundled_products?.length > 0){
            return(
                <>
                    {product?.bundled_products?.map((each, j)=>(
                        <React.Fragment key={`recursive-bundled-products-${j}`}>
                            {getTokensList(each, true)}
                        </React.Fragment>
                    ))}
                </>
            )
        }
    }

    const addComma = (length, index, period=false)=>{
        if (length-1 === index && !period) return ""
        else if (length-1 === index && period) return "."
        else if(length > index) return ","
    }

    const getTokenSentence=(product, includeName, length, index)=>{
        
        if(product?.product_type_id === TOKEN_ITEM_TYPE_ID){
            return(
                <span>
                    {product?.quantity} {includeName && `"${product.name}"`} token{product.quantity > 1 ? "s" : ""}
                    {addComma(length, index)}
                </span>
            )
        }else if(product?.product_type_id === BUNDLE_ITEM_TYPE_ID && product?.bundled_products?.length > 0){
            return(
                <>
                    {product?.bundled_products?.map((each, j)=>(
                        <React.Fragment key={`recursive-bundled-products-${j}`}>
                            {getTokenSentence(each, true, product?.bundled_products?.length, j)}
                        </React.Fragment>
                    ))}
                </>
            )
        }
    }

    if(item?.product_type_id !== BUNDLE_ITEM_TYPE_ID && item?.product_type_id !== TOKEN_ITEM_TYPE_ID) return null;

    return(
        <div>
            {type==="list" &&
                <>
                    This bundle inclues the following:
                        <ul>
                            {item?.bundled_products?.map((product, i)=>(
                                <li key={`bundled-product-list-${i}`}>
                                    {product?.name}
                                    {product?.product_variants.length === 1 && product.product_variants[0]?.name !== "Default" ? 
                                        `(${product.product_variants[0].name})` 
                                        : 
                                        "" 
                                    }
                                    <ul>
                                        {getTokensList(product, false)}
                                    </ul>
                                </li>
                            ))}
                        </ul>
                </>
            }
            {type==="sentence" &&
                <p>
                    This bundle includes 
                    {item.bundled_products?.map((product, i)=>(
                        <span key={`sentence-version-included-token-products-${i}`}>
                            {" "} "{product.name}"
                            {product?.product_variants.length === 1 && product.product_variants[0]?.name !== "Default" ? 
                                `(${product.product_variants[0].name})`
                                : 
                                "" 
                            }:
                            ({getTokenSentence(product, false, item?.bundled_products?.length, i)})
                            {addComma(item?.bundled_products?.length, i, true)}
                        </span>
                    ))}
                </p>
            }
        </div>
    )
}